import styled from 'styled-components';
import { flexCenter, circle } from '../../helpers/style-helpers';

type TAvatarSC = {
  size?: number;
};
export const AvatarSC = styled.div<TAvatarSC>`
  ${flexCenter}
  ${({ size }) => circle(size || 36)}

  position: relative;

  /* background: linear-gradient(270deg, #DA7D8D 0%, #BA4352 100%);
  box-shadow: 0 2px 8px 0 rgba(201,95,110,0.4);
  background: linear-gradient(270deg, #4F5C9A 0%, #333D6C 100%);
  box-shadow: 0 2px 8px 0 rgba(51,61,108,0.4); */

  > img {
    ${({ size }) => circle(size ? size - 2 : 34)}

    background: #fff;
  }

  .avatar-notifications {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .avatar-check {
    position: absolute;
    bottom: 0;
    right: 0;
    ${({ size }) => {
      return `
        height: ${size ? `${size * 0.4}px` : `${38 * 0.4}px`};
        width: ${size ? `${size * 0.4}px` : `${38 * 0.4}px`}
      `;
    }}
  }
`;
